import React, { useEffect, useCallback, Fragment } from 'react';
import { debounce } from 'lodash';

const ResiizeObserver = ({
  children,
  targetNodeRef,
  handleCallBack,
  debounceInterval = 350
}) => {
  const debounceDivChange = useCallback(
    debounce(handleCallBack, debounceInterval),
    []
  );

  useEffect(() => {
    if (!targetNodeRef) return;
    const targetNode = targetNodeRef?.current;
    const observer = new ResizeObserver(debounceDivChange);
    observer.observe(targetNode);
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="w-full" ref={targetNodeRef}>
      {children}
    </div>
  );
};

export default ResiizeObserver;
